// OMAR HASSAN | Mohamed A. Abdallah
document.addEventListener('DOMContentLoaded', () => {
  // --- Configuration ---
  const loadMoreButtonSelector = '#load-more-button';
  const productGridSelector = 'ul#collection';
  const scrollThreshold = 600;

  const loadMoreButton = document.querySelector(loadMoreButtonSelector);
  const productGrid = document.querySelector(productGridSelector);
  let isLoading = false;
  let lastScrollPosition = 0;

  if (loadMoreButton && productGrid) {
    // Hide the button using JS
    loadMoreButton.style.display = 'none';

    // Function to check if the user has scrolled near the bottom
    const isNearBottom = () => {
      const gridRect = productGrid.getBoundingClientRect();
      return (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - scrollThreshold);
    };

    // Function to load the next page
    const loadNextPage = () => {
      const stillHasButton = document.querySelector(loadMoreButtonSelector);

      if (stillHasButton && !isLoading) {
        isLoading = true;
        lastScrollPosition = document.scrollY; // Save current scroll position

        // Trigger the button click
        const href = stillHasButton.href;
        if (!String(href).includes("#root")) {
          stillHasButton.click();
        }

        // Use MutationObserver to detect when new content is added
        const observer = new MutationObserver((mutations) => {
          if (mutations.some(mutation => mutation.addedNodes.length > 0)) {
            isLoading = false;
            observer.disconnect();
            // Restore scroll position after a short delay to let content render
            setTimeout(() => {
              document.scrollTo(0, lastScrollPosition);
              if (isNearBottom()) {
                loadNextPage();
              }
            }, 100);
          }
        });

        observer.observe(productGrid, { childList: true, subtree: true });
      } else if (!stillHasButton && !isLoading) {
        console.log('No more products to load.');
        document.removeEventListener('scroll', handleScroll);
      }
    };

    // Scroll event handler
    const handleScroll = () => {
      if (isNearBottom() && !isLoading) {
        loadNextPage();
      }
    };

    // Add the scroll event listener
    document.addEventListener('scroll', handleScroll);

    // Check on page load
    setTimeout(() => {
      if (isNearBottom()) {
        loadNextPage();
      }
    }, 100);
  } else {
    console.error('Infinite scroll setup failed: "Show more" button or product grid not found.');
  }
});